import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import HelpIcon from '@material-ui/icons/Help';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import useStyles from '../styles';

const MaterialTableActions = ({ 
  rowData, 
  handleViewDetails, 
  onPassMaterial, 
  handleFinishMaterial 
}) => {
  const classes = useStyles();

  if (rowData.estado_nombre === 'Finalizado') {
    return <Typography>Finalizado</Typography>;
  }

  return (
    <div className={classes.actionBtnsContainer}>
      <IconButton
        className={classes.actionBtn}
        onClick={() => handleViewDetails({ material: rowData.id })}
      >
        <VisibilityIcon />
      </IconButton>

      {rowData.fg !== 2 &&
       rowData.fg !== 1 &&
       rowData.fc !== 1 &&
       rowData.fc !== 2 && (
        <>
          <IconButton
            className={classes.actionBtn}
            onClick={() => onPassMaterial({ material: rowData.id })}
          >
            <HelpIcon />
          </IconButton>

          <IconButton
            className={classes.actionBtn}
            onClick={() => handleFinishMaterial({ material: rowData.id })}
          >
            <AssignmentTurnedInIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};

MaterialTableActions.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    estado_nombre: PropTypes.string,
    fg: PropTypes.number,
    fc: PropTypes.number
  }).isRequired,
  handleViewDetails: PropTypes.func.isRequired,
  onPassMaterial: PropTypes.func.isRequired,
  handleFinishMaterial: PropTypes.func.isRequired
};

export default MaterialTableActions;
